var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Collection } from 'hanako-ts/dist-legacy/Collection';
import { Swiper } from '../../../../ts/helpers/Swiper';
export class Single extends Component {
    constructor() {
        super('Single', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            Single.galleryContainer = $('.gallery-single');
            $('.gallery-thumbnails a').on('click', (event, thumbnail) => {
                event.preventDefault();
                Single.galleryContainer.removeClass('d-none').empty();
                $('.column-informations, .gallery-thumbnails').addClass('d-none');
                $('.thumbnail').each((thumbnail) => {
                    let html = new Collection();
                    if (thumbnail.data('youtubeCode') != '') {
                        html = $.parseHTML('<div class="video image" data-legend="' + thumbnail.data('legend') + '"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + thumbnail.data('youtubeCode') + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
                    }
                    else {
                        html = $.parseHTML('<div class="image" style="background-image:url(\'' + thumbnail.attr('href') + '\')" data-legend="' + thumbnail.attr('data-legend') + '">');
                    }
                    Single.galleryContainer.append(html);
                });
                let index = Array.prototype.indexOf.call(thumbnail.parent().get(0).children, thumbnail.get(0));
                Single.initGallery(index);
            });
            Single.initGallery();
            this.success();
        });
    }
    static initGallery(index = 0) {
        Single.images = $('.gallery-single .image');
        if (Single.images.length == 0)
            return;
        $('body').addClass('no-overflow');
        Single.images.addClass('d-none');
        Single.currentImage = index;
        Single.images.eq(Single.currentImage).removeClass('d-none');
        Single.showLegend();
        $('.legend, .btn-close').removeClass('d-none');
        $(window).on('keydown', (event) => {
            if (event.key == 'ArrowLeft')
                Single.prevPicture();
            if (event.key == 'ArrowRight')
                Single.nextPicture();
        });
        $('.btn-close').on('click', function () {
            $('body').removeClass('no-overflow');
            $('.column-informations, .gallery-thumbnails').removeClass('d-none');
            $('.gallery-single, .legend, .btn-close').addClass('d-none');
        });
        Single.galleryContainer.on('click', '.image', Single.nextPicture);
        $('.btn-previous').on('click', Single.prevPicture);
        $('.btn-next').on('click', Single.nextPicture);
        const swiper = new Swiper($('.gallery-single'));
        swiper.on('swipeLeft', () => {
            Single.nextPicture();
        });
        swiper.on('swipeRight', () => {
            Single.prevPicture();
        });
    }
    static showLegend() {
        if (!Single.images)
            return;
        $('.legend .text').text(Single.images.eq(Single.currentImage).data('legend'));
    }
    static prevPicture() {
        Single.currentImage--;
        if (Single.currentImage < 0)
            Single.currentImage = Single.images.length - 1;
        Single.showImage(Single.currentImage);
    }
    static nextPicture() {
        Single.currentImage++;
        if (Single.currentImage >= Single.images.length)
            Single.currentImage = 0;
        Single.showImage(Single.currentImage);
    }
    static showImage(index) {
        Single.images.addClass('d-none');
        Single.images.eq(index).removeClass('d-none');
        Single.showLegend();
    }
}
